import React from "react";
import styles from './Spinner.module.less';
export function Spinner({ radius = '20px' }) {
    return (React.createElement("svg", { viewBox: "0 0 50 50", width: radius, height: radius, className: styles.root },
        React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "3" })));
}
